// The colours of a badge. The first ones are the tones of the CRM prototype:
// neutral grey, red for what is late or refused, green for what is done,
// orange for what waits. The registration sources keep their own.
const TYPE_COLOR = {
  PRIMARY: 'bg-gray-100 text-gray-700',
  SECONDARY: 'border border-gray-200 bg-gray-50 text-gray-700',
  // White with a grey border: a state beside the row's actions (« Invitation en attente »).
  OUTLINE: 'border border-gray-200 bg-white text-gray-700',
  ALERT: 'bg-red-50 text-red-700',
  WARNING: 'bg-yellow-50 text-yellow-700',
  VALID: 'bg-green-50 text-green-700',
  // A group, and a contact who recommends Jobbiz (« Ambassadeur »).
  INFO: 'bg-blue-50 text-blue-700',
  AMBER: 'bg-amber-50 text-amber-700',
  APP: 'bg-[#FAF5FF] text-[#9333EA]',
  WEB: 'bg-yellow-50 text-yellow-600',
  INDEED: 'bg-blue-50 text-blue-600',
  // The sector tags of jobbiz_app_v2 (theme/colors.js, `sector`), which the
  // prototype gives to the sectors and to the task types.
  SECTOR_GREEN: 'bg-[#dff7df] text-[#2e7d32]',
  SECTOR_ORANGE: 'bg-[#ffeacc] text-[#e65100]',
  SECTOR_INDIGO: 'bg-[#d9ddff] text-[#303f9f]',
  SECTOR_PURPLE: 'bg-[#efd5f9] text-[#7b1fa2]',
  SECTOR_SLATE: 'bg-[#dde7ec] text-[#455a64]',
  SECTOR_GREY: 'bg-[#eeeeee] text-[#616161]',
  SECTOR_BLUE: 'bg-[#d4e5ff] text-[#0d47a1]',
};

// SM is the prototype's badge (the md Tag of jobbiz_app_v2): 12px medium,
// 12 × 4 of padding, corners of 8. LG is the same, one step larger.
const SIZE = {
  SM: 'px-3 py-1 text-xs leading-4',
  LG: 'px-3 py-2 text-sm leading-5',
};

const Badge = ({ type, size, children }) => (
  <div
    className={`inline-flex max-w-full items-center justify-center gap-1 truncate whitespace-nowrap rounded-lg font-medium ${
      SIZE[size] ?? SIZE.SM
    } ${TYPE_COLOR[type] ?? TYPE_COLOR.PRIMARY}`}
  >
    {children}
  </div>
);

export default Badge;
